module.exports = __webpack_public_path__ + "static/media/empty.71b56f70.svg";